var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component-button-selector", class: _vm.computedClass },
    [
      _c(
        "div",
        { staticClass: "_button-selector-wrap" },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.matched,
                  expression: "matched"
                }
              ],
              staticClass: "_result-inp-wrap"
            },
            [
              _vm.matched
                ? _c("p", { staticClass: "_result-label synormal" }, [
                    _vm._v(_vm._s(_vm.matched.label))
                  ])
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "_result-clean",
                  on: {
                    click: function($event) {
                      return _vm.handleInput(null)
                    }
                  }
                },
                [_c("Close", { attrs: { width: "14px" } })],
                1
              )
            ]
          ),
          _c(
            "Button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.matched,
                  expression: "!matched"
                }
              ],
              staticClass: "_btn-selector",
              attrs: { size: _vm.size, skin: "grey" }
            },
            [_vm._v(_vm._s(_vm.label))]
          ),
          _c(
            "Select",
            {
              staticClass: "_component-select",
              attrs: { value: _vm.value },
              on: { input: _vm.handleInput }
            },
            _vm._l(_vm.options, function(item) {
              return _c("Option", {
                key: item.value,
                attrs: { label: item.label, value: item.value }
              })
            }),
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }